// import { asyncRoutes } from '@/router'

const state = {
  routes: JSON.parse(localStorage.getItem('routes')) || [], // 防止用户直接刷新界面，从缓存中读原来的数据
  addRoutes: []
}
const mutations = {
  SET_ROUTES(state, payload) {
    state.routes = [ ...payload]
  }
}
// 遍历asyncRoutes动态路由
function forSearchArr(route, roles) {
  let arrNew = []
  for (let item of route) {
    let itemNew = { ...item } //解决浅拷贝共享同一内存地址
    for(let val of roles) {
      if (val.name === itemNew.name) {
        if (itemNew.children) {
          itemNew.children = forSearchArr(itemNew.children, roles)
        }
        arrNew.push(itemNew)
      }

    }



  }
  return arrNew
}
const actions = {
  getAsyncRoutes({ commit, rootGetters }, res) {
    // return new Promise(resolve => {
    //   let routes = []
    //   if (rootGetters.userName === 'admin') {
    //     routes = asyncRoutes || ''
    //   } else {
    //
    //     routes = forSearchArr(asyncRoutes, roles) // asyncRoutes是异步要加上去的， roles 是全部能看到的
    //
    //     console.log(routes)
    //   }
    //   commit('SET_ROUTES', routes)
    //   resolve(routes)
    // })


  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
